<template>	
   <div class="analy-box">
        <div class="main-title">
            <span class="main-back" @click="goBack"></span>
            <h3>数据分析</h3>
        </div>
        <ul class="allData">
            <li class="data-item">
                <div class="data-box" style="border-right:1px solid #e1e1e1;">
                    <div class="nums">
                          {{allData.readpv}}
                    </div>
                    <div class="text">
                       总阅读数
                    </div>

                </div>
            </li>
            <li class="data-item">
                  <div class="data-box" style="border-right:1px solid #e1e1e1;">
                    <div class="nums">
                           {{allData.commentpv}}
                    </div>
                    <div class="text">
                        总评论数 
                    </div>

                </div>

            </li>
            <li class="data-item">
                  <div class="data-box">
                    <div class="nums">
                          {{allData.contentnum}}
                    </div>
                    <div class="text">
                       总文章数
                    </div>

                </div>

            </li>
        </ul>
        <div class="tab-box">
           <ul class="tabss">
               <li class="tab-item" :class="{'active-tab':currentTab == '1'}" @click="tabClick('1')">阅读数</li>
               <li class="tab-item" :class="{'active-tab':currentTab == '2'}"  @click="tabClick('2')">评论数</li>
               <li class="tab-item" :class="{'active-tab':currentTab == '3'}" @click="tabClick('3')">文章数</li>
           </ul>
        </div>
        <div  style="width:100%;height:6rem;padding:0px 5px">
             <div id="echartsDom" style="width:100%;height:6rem">

             </div>
        </div>
   </div>
</template>
<script>
import echarts from 'echarts'
import {datasurvey} from './../../axios/api.js'
import {dateFormat} from './../../common/js/util.js'
	export default {
	  	data() {
		    return {
             currentTab:'1',
             allData:{
                 readpv:0,
                 commentpv:0,
                 contentnum:0
             },
             dateList:[],
             readList:[],
             commentList:[],
             contentList:[]

		    }
	  	},
	  	components: {
	
  		},      
        mounted(){
          this.queryData()
          this.initEcharts();  
        },
        methods: {
            queryData(){
                let date1 = new Date(new Date().getTime() -3600 * 1000 * 24 * 7 );
                let date2 = new Date(new Date().getTime() -3600 * 1000 * 24 * 1 );
                let stdate = dateFormat('yyyyMMdd',date1);
                let enddate = dateFormat('yyyyMMdd',date2);
                datasurvey({stdate,enddate}).then(res =>{
                    if(res.code == '0'){
                        this.allData.readpv = res.data.readpv;
                        this.allData.contentnum = res.data.contentnum;
                        this.allData.commentpv = res.data.commentpv;
                        if(res.data.bydaylist){
                           res.data.bydaylist.forEach((ele,index) =>{
                              this.dateList.push(ele.dt);
                               this.readList.push(ele.read_pv);
                                this.commentList.push(ele.comment_pv);
                                 this.contentList.push(ele.passtotal);

                           });
                        }
                        this.initEcharts(this.dateList,this.readList,['#C1232B']);
                    }else{
                         this.$layer.dialog({
                            content: res.msg,
                            time: 2000
                        });
                    }
                }).catch(err =>{
                      this.$layer.dialog({
                            content: "网络错误",
                            time: 2000
                        });
                })
            },
           	goBack (){
				this.$router.go(-1);
            },
            tabClick(index){
                this.currentTab = index;
                if(index == '1'){
                    this.initEcharts(this.dateList,this.readList,['#C1232B']);
                }else if(index == '2'){
                    this.initEcharts(this.dateList,this.commentList,['#B5C334']);
                }else if(index == '3'){
                    this.initEcharts(this.dateList,this.contentList,['#27727B']);
                }
            },
            initEcharts(dateList,dataList,colorList){
                if(!dateList){
                   dateList = [];
                }
                if(!dataList){
                  dataList = [];
                } 
                let myChart = echarts.init(document.getElementById('echartsDom'));
                let option = {
                   // color:  [ '#C1232B','#B5C334','#FCCE10','#E87C25','#27727B'],
                   color:  colorList,
                    tooltip : {
                        trigger: 'axis'
                    },
                    toolbox: {
                        show : false,
                    },
                    calculable : true,
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data :dateList
                        }
                    ],
                    yAxis : [
                        {
                            type : 'value',
                            axisLabel : {
                                formatter: '{value}'
                            }
                        }
                    ],
                    series : [
                        // {
                        //     name:'最高气温',
                        //     type:'line',
                        //     data:[11, 11, 15, 13, 12, 13, 10],
                        // },
                        {
                            name:'最低气温',
                            type:'line',
                            data:dataList,
                        }
                    ]
                };
                myChart.setOption(option);
            }
        }
	}
</script>
<style scoped>
.analy-box{
    font-size: 0.28rem;

}
.main-title {
    position: relative;
}
.main-title .main-back{
    float: left;
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    background: url('./../../assets/img/back-btn.png') no-repeat center center;
    background-size: 0.45rem 0.45rem;
    position: absolute;
    top:  0.2rem;
    left: 0.1rem;
}
.main-title h3{
	    background: #fff;
	    line-height: 0.9rem;
	    font-size: 0.34rem;
	    font-weight: normal;
	    color: #333333;
	    text-align: center;
    }
.allData{
    width:100%;
    overflow: hidden;
    border-top:1px solid #e1e1e1;
     border-bottom:1px solid #e1e1e1;
    
    
}
.data-item{
    width:33%;
    float: left;
}
.data-box{
    margin:15px 0px;
    
    padding:10px 0px;
}
.nums{
    font-size: 0.32rem;
    margin-bottom:5px;
}
.tabss{
    width:100%;
    overflow: hidden;  
    margin:5px 10px;
   
}
 .tab-item{
        float: left;
        margin:0px 15px; 
        padding:5px 0px;
    }
    .active-tab{
        border-bottom: 1px solid red;
        color:red;
    }
</style>


// WEBPACK FOOTER //
// src/components/analysis/analysisMain.vue